import { Container, FloatingLabel, Form, Modal } from 'react-bootstrap';
import { FC, useMemo, useState } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import { userServices } from 'src/services';

type propsType = {
    closeModal: () => void;
    currentUser: typeUser;
};

export const UsersChangeEmailModal: FC<propsType> = ({ closeModal, currentUser }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [newEmailAddress, setNewEmailAddress] = useState('');
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    const isValid: boolean = useMemo(() =>
        generalHelpers.IsValidEmail(newEmailAddress)
    , [newEmailAddress]);

    const save = () => {
        if (!isValid) {
            return;
        }
        setErrorMessage('');
        dispatch(setValuesAndOpenAlertModalReducer({
            title: 'Confirmar',
            message: `Se guardará el nuevo email del usuario ${currentUser.email}: ${newEmailAddress}`,
            mode: 'confirm',
            animation: 3,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await userServices.ChangeEmailByAdmin(currentUser.id, newEmailAddress, currentUser.email);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    setErrorMessage(`${response.message.title} | ${response.message.description}`);
                    return;
                }
                closeModal();
            }
        }));
    }

    return (
        <Modal show size={'lg'} fullscreen={'md-down'} onHide={closeModal}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    Datos personales de {currentUser.email}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark' : ''}>
                <Container style={{ maxWidth: '500px', padding: isMobile ? '35px 30px 0' : '35px 0 0' }}>
                    <FloatingLabel className={'mb-3 text-dark'}
                        label={'Email actual'}
                    >
                        <Form.Control type={'text'}
                            className={'form-control'}
                            placeholder={''}
                            value={currentUser.email}
                            disabled
                        />
                    </FloatingLabel>
                    <FloatingLabel className={'mb-3 text-dark'}
                        label={'Nuevo email'}
                    >
                        <Form.Control type={'text'}
                            className={'form-control'}
                            placeholder={'Nueva dirección de email'}
                            value={newEmailAddress}
                            onChange={e => setNewEmailAddress(e.target.value)}
                            autoFocus
                        />
                    </FloatingLabel>
                    <div className={isDarkMode ? 'text-white' : ''}>
                        La nueva dirección de email del usuario será también su nombre de usuario y tendrá que usarlo para ingresar a la aplicación. No olvidar informarle del cambio.
                    </div>
                    <div className={isDarkMode ? 'text-white' : ''}>
                        La aplicación no admite que el mismo correo electrónico sea usado por más de un usuario, sin diferenciar entre congregaciones.
                    </div>
                    {errorMessage &&
                        <div className={'bg-danger text-white p-2 mt-2'}>
                            {errorMessage}
                        </div>
                    }
                    <button className={'btn btn-general-blue d-block w-100 mt-4'}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={save}
                        disabled={!isValid}
                    >
                        GUARDAR
                    </button>
                    <button className={`btn btn-general-red d-block w-100 mt-2 mb-3`}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={closeModal}
                    >
                        CANCELAR
                    </button>
                </Container>
            </Modal.Body>
        </Modal>
    );
}
